export default __webpack_public_path__ + "static/media/character8.92d3b4bf.png";